import { render, staticRenderFns } from "./historyReport.vue?vue&type=template&id=0830b702"
import script from "./historyReport.vue?vue&type=script&lang=js"
export * from "./historyReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports